import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import NoCardFound from "../assets/card_not_found.png"; // Assume responsive handling in CSS if needed

const CardNotExist = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <Header />
      <div className="flex-1 flex items-center justify-center p-4">
        <div
          className="relative w-full max-w-4xl h-[80vh] flex flex-col items-center justify-center rounded shadow bg-no-repeat bg-center bg-contain"
          style={{ backgroundImage: `url(${NoCardFound})` }}
        >
          <div className="absolute inset-0 bg-white bg-opacity-70" />
          <div className="relative z-10 text-center p-6 max-w-xl">
            <h2 className="text-2xl font-semibold text-red-600 mb-4">Няма намерена картичка</h2>
            <p className="text-gray-700 mb-6">
              Картичката, която се опитвате да достъпите, не съществува. Моля, сканирайте отново баркода от картичката или се обърнете към търговския обект, от който сте я закупили.
            </p>
            <button
              onClick={() => navigate("/")}
              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
              aria-label="Върни се на началната страница"
            >
              Начало
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardNotExist;